module.exports = "/work-site/img/weight.fff2f1ad.png";